module.exports = __webpack_public_path__ + "img/yinmou.da094874.png";